import React from "react"

// Mui
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme
} from "@mui/material"

// Next Image
import Image from "next/image"

// Icons
import Instagram from "public/images/icons/instagram.png"
import Telegram from "public/images/icons/telegram.png"
import WhatsApp from "public/images/icons/whatsapp.png"

import Link from "next/link"
import Mellat from "public/images/MellatBank.png"
import sls from "public/images/sls.png"
import Shaghayegh from "public/images/Shaghayegh.svg"
import { Link as ScrollLink } from "react-scroll"
import { Add, Location, Message, Mobile, Printer, Send as Mail } from "iconsax-react"
import { alpha } from "@mui/material/styles"
import BasicLogo from "../../../../common/BasicLogo"
import Pages from "src/constants/pages"

const MobileFooter = () => {
  // Use Theme
  const theme = useTheme()

  // service
  const services = [
    { title: "ثبت نام", href: "/register", page: true },
    { title: "ورود", href: "/login", page: true },
    { title: "ماشین حساب", href: "calculator" },
    { title: "تراکنش ها", href: Pages.Transactions, page: true },
    { title: "دریافت وام", href: Pages.Facilities, page: true },
    { title: "پرداخت اقساط", href: "/payInstallment/0", page: true },
    { title: "درخواست پذیرندگی", href: "/merchant/request", page: true },
    { title: "درخواست تسهیلات سازمانی", href: Pages.Main, page: true }
  ]

  const accessList = [
    { title: "صفحه اصلی", href: Pages.Main, page: true },
    { title: "سایت مهندسی نرم افزار شقایق", href: "https://shsoftco.com", page: true },
    { title: "سرویس های خاص", href: "#", page: true }
  ]

  const about = [
    { title: "تماس با ما", href: "#" },
    { title: "اخبار و اطلاعیه ها", href: "#" },
    { title: "درباره ما", href: "#" }
  ]

  const popupOptions =
    "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"

  return (
    <Box sx={{ background: theme.palette.background.paper, mt: 6, p: 3 }}>
      <Stack spacing={2}>
        <Stack justifyContent='center'>
          <Stack justifyContent='flex-start' alignItems={"center"} sx={{ cursor: "pointer" }}>
            <BasicLogo />
            {/* <Image src={Shaghayegh} alt='جت وام' width={160} /> */}
            <Stack direction="row" alignItems={"center"}>
              <Image src={sls} alt='راهکار سرزمین هوشمند' width={100} />
              <Image src={Shaghayegh} alt='جت وام' width={160} />
            </Stack>
          </Stack>
        </Stack>
        <Typography variant='subtitle2' textAlign='center'>
          با جت وام هرجایی که هستی فقط کافیه به اینترنت متصل باشی و با چک صیادی و بدون دردسر و خیلی سریع وام بگیری.
        </Typography>
      </Stack>
      <Accordion
        color='primary'
        elevation={0}
        sx={{
          mt: 6,
          mb: 1,
          borderRadius: "10px",
          "&::before": { height: "0" }
        }}
      >
        <AccordionSummary expandIcon={<Add size={18} color={theme.palette.primary.main} />}>
          <Typography fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            خدمات
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2} sx={{ textAlign: "start" }}>
            {services?.map((item, index) => (
              <Typography
                to={item.href}
                component={item.page ? Link : ScrollLink}
                key={index}
                href={item.href}
                target={item.page ? "_blank" : ""}
                variant='caption'
              >
                {item?.title}
              </Typography>
            ))}
          </Stack>
        </AccordionDetails>
      </Accordion>
      <Accordion
        color='primary'
        elevation={0}
        sx={{
          mb: 1
        }}
      >
        <AccordionSummary expandIcon={<Add size={18} color={theme.palette.primary.main} />}>
          <Typography fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            دسترسی ها
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2} sx={{ textAlign: "start" }}>
            {accessList?.map((item, index) => (
              <Typography
                to={item.href}
                component={item.page ? Link : ScrollLink}
                key={index}
                href={item.href}
                target={item.page ? "_blank" : ""}
                variant='caption'
              >
                {item?.title}
              </Typography>
            ))}
          </Stack>
        </AccordionDetails>
      </Accordion>
      <Accordion
        color='primary'
        elevation={0}
        sx={{
          mb: 1
        }}
      >
        <AccordionSummary expandIcon={<Add size={18} color={theme.palette.primary.main} />}>
          <Typography fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            درباره ما
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/* <Stack spacing={2} sx={{ textAlign: "start" }}>
            {about?.map((item, index) => (
              <Typography
                to={item.href}
                component={item.page ? Link : ScrollLink}
                key={index}
                href={item.href}
                target={item.page ? "_blank" : ""}
                variant='caption'
              >
                {item?.title}
              </Typography>
            ))}
          </Stack> */}
          <Typography mt={2} variant='subtitle2'>
            شرکت مهندسی نرم افزار شقایق به عنوان یکی از شرکت های زیر مجموعه هلدینگ فناوران هوشمند بهسازان فردا ( متعلق
            به بانک ملت ) با هدف افزایش قدرت خرید مردم ، و اعطای تسهیلات اعتباری خرید از شبکه منتخب پذیرندگان در کوتاه
            ترین زمان ، اقدام به راه اندازی جت وام نموده است.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        color='primary'
        elevation={0}
        sx={{
          mb: 1
        }}
      >
        <AccordionSummary expandIcon={<Add size={18} color={theme.palette.primary.main} />}>
          <Typography fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            ارتباط با ما
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={1}>
            {/* <List component='nav'>
              <ListItem sx={{ px: 0, paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemIcon>
                  <Mobile color={theme.palette.primary.main} />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography>تلفن</Typography>}
                  secondary={<Typography sx={{ color: "#a94354" }}>پشتیبانی متقاضیان</Typography>}
                />
              </ListItem>

              <ListItem sx={{ marginLeft: "2rem", paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemText
                  primary={
                    <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>021-42067385</Typography>
                  }
                />
              </ListItem>
              <ListItem sx={{ marginLeft: "2rem", paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemText
                  primary={
                    <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>021-42067456</Typography>
                  }
                />
              </ListItem>
              <ListItem sx={{ marginLeft: "2rem", paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemText
                  primary={
                    <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>021-42067378</Typography>
                  }
                />
              </ListItem>
              <ListItem sx={{ marginLeft: "2rem", paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemText
                  primary={
                    <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>021-42067383</Typography>
                  }
                />
              </ListItem>

              <ListItem sx={{ px: 0, paddingTop: "0px", paddingBottom: "0px", marginLeft: "3.5rem" }}>
                <ListItemText
                  primary={<Typography> </Typography>}
                  secondary={<Typography sx={{ color: "#a94354" }}> امور پذیرندگان</Typography>}
                />
              </ListItem>
              <ListItem sx={{ marginLeft: "2rem", paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemText
                  primary={
                    <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>021-42067777</Typography>
                  }
                />
              </ListItem>
            </List> */}
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon>
                <Mobile color={theme.palette.primary.main} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography>تلفن</Typography>}
                secondary={<Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>1658</Typography>}
              />
            </ListItem>
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon>
                <Printer color={theme.palette.primary.main} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography>فکس</Typography>}
                secondary={
                  <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>02188499648</Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon>
                <Mail color={theme.palette.primary.main} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography>ایمیل</Typography>}
                secondary={
                  <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>Info@jetvam.ir</Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon>
                <Message color={theme.palette.primary.main} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography>کد پستی</Typography>}
                secondary={
                  <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>1415874611</Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon>
                <Location color={theme.palette.primary.main} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography>آدرس</Typography>}
                secondary={
                  <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>
                    تهران، خیابان ولیعصر، بالاتر از تقاطع زرتشت، کوچه نوربخش، پلاک 16
                  </Typography>
                }
              />
            </ListItem>
          </Stack>
        </AccordionDetails>
      </Accordion>
      {/*// -------------------------------------------------------------------------------------------------------------*/}

      <Divider sx={{ my: 3, borderStyle: "dashed" }} />
      <Stack direction='row' alignItems='center' spacing={2} justifyContent='center'>
        {/* <Typography variant='caption'>حریم خصوصی</Typography>
        <Divider orientation='vertical' variant='middle' flexItem /> */}
        {/* <Typography variant='caption'>شرایط استفاده</Typography>
        <Divider orientation='vertical' variant='middle' flexItem /> */}
        <Typography component={Link} href={Pages.LoanGuide} variant='caption'>
          راهنمای دریافت وام
        </Typography>
        <Divider orientation='vertical' variant='middle' flexItem />
        <Typography variant='caption' component={Link} href='/rules'>
          قوانین و مقررات
        </Typography>
      </Stack>
      {/* <Stack direction='row' justifyContent='center' alignItems='center' spacing={3} mt={3}>
        <Image src={Instagram} alt='instagram' width={25} />
        <Image src={Telegram} alt='telegram' width={25} />
        <Image src={WhatsApp} alt='whatsapp' width={25} />
      </Stack> */}
      <Grid display='flex' alignItems={"center"} justifyContent={"center"} mt={"20px"}>
        <Grid width={"50%"} display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <Grid display={"flex"} alignItems={"center"} gap={1.5} justifyContent={"flex-start"}>
            <Grid
              mt={"15px"}
              display='flex'
              alignItems={"center"}
              justifyContent={"center"}
              border={"1px solid #e0e0e6"}
              borderRadius={"8px"}
              p={"10px"}
            >
              <a
                referrerPolicy='origin'
                target='_blank'
                href='https://trustseal.enamad.ir/?id=345190&amp;Code=M437MprMOKoxcUmyXdiY'
              >
                <img
                  src={`https://Trustseal.eNamad.ir/logo.aspx?id=345190&Code=M437MprMOKoxcUmyXdiY`}
                  width={"60px"}
                  height={"52px"}
                />
              </a>
            </Grid>
            <Grid
              mt={"15px"}
              display='flex'
              alignItems={"center"}
              justifyContent={"center"}
              border={"1px solid #e0e0e6"}
              borderRadius={"8px"}
              style={{ cursor: "pointer" }}
              p={"10px"}
              onClick={() =>
                window.open(
                  "https://logo.samandehi.ir/Verify.aspx?id=360767&p=xlaogvkaobpdjyoegvkajyoe",
                  "Popup",
                  popupOptions
                )
              }
            >
              <img
                referrerPolicy='origin'
                id='rgvjfukzesgtjzpefukzjzpe'
                alt='logo-samandehi'
                src='https://logo.samandehi.ir/logo.aspx?id=360767&p=qftiwlbqlymayndtwlbqyndt'
                width={"60px"}
                height={"60px"}
              />
            </Grid>
            <Grid
              mt={"15px"}
              display='flex'
              alignItems={"center"}
              justifyContent={"center"}
              border={"1px solid #e0e0e6"}
              borderRadius={"8px"}
              p={"10px"}
              width={"82px"}
              height={"82px"}
              sx={{ cursor: "pointer" }}
            >
              <Image src={Mellat} alt='لوگو بانک ملت' width={100} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Stack mt={4} direction='row' alignItems='center' spacing={3} justifyContent='center'>
        <Typography variant='caption'>Copyright © 2023 jet vam</Typography>
      </Stack>
    </Box>
  )
}

export default MobileFooter
